import { compact } from 'lodash/fp';
import { createSelector } from 'reselect';
import { TextKey, RouteName, FeatureFlag } from '@mews-commander/enums';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import {
    hasCurrentProfileAnyServicePrivileges,
    canCurrentProfileManageEnterpriseEmployees,
    canCurrentProfileConfigureEnterprise,
} from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { getFeatureFlagService } from '@mews-commander/legacy-app-instance';
import { getSimpleSearchResult } from './getSimpleSearchResult';
import { SearchResult } from './types';

export default createSelector(
    getCurrentEnterpriseId,
    canCurrentProfileManageEnterpriseEmployees,
    hasCurrentProfileAnyServicePrivileges,
    canCurrentProfileConfigureEnterprise,
    (
        enterpriseId: string,
        isEmployeeManager: boolean,
        canConfigureService: boolean,
        canConfigureEnterprise: boolean
    ) => {
        const contractingTemplateMappingEnabled = getFeatureFlagService().hasFlag(
            FeatureFlag.contractingTemplateMappingEnabled
        );
        return compact<SearchResult>([
            isEmployeeManager
                ? getSimpleSearchResult({
                      routeName: RouteName.UserManagementPropertyUsersIndex,
                      titleKey: TextKey.EmployeePlural,
                  })
                : null,
            canConfigureEnterprise && enterpriseId
                ? getSimpleSearchResult({
                      titleKey: TextKey.Property,
                      routeName: RouteName.EnterpriseDetail,
                      params: { enterpriseId },
                  })
                : null,
            canConfigureService
                ? getSimpleSearchResult({
                      routeName: RouteName.ServiceIndex,
                      titleKey: TextKey.ServicePlural,
                      params: { query: { OwnerId: enterpriseId } },
                  })
                : null,
            contractingTemplateMappingEnabled
                ? getSimpleSearchResult({
                      routeName: RouteName.ReservationContracts,
                      titleKey: TextKey.ContractsListPageTitle,
                  })
                : null,
        ]);
    }
);
